const expenseverseProductReducer = (products = [], action) => {
    switch (action.type) {
        case 'FETCH_ALL_EXPENSEVERSE_PRODUCTS':
            return action.payload;
        case 'CREATE_EXPENSEVERSE_PRODUCT':
            return [...products, action.payload];
        case 'UPDATE_EXPENSEVERSE_PRODUCT':
            return products.map((product) => (product._id === action.payload._id ? action.payload : product));
        case 'DELETE_EXPENSEVERSE_PRODUCT':
            return products.filter((product) => product._id !== action.payload);
        default:
            return products;
    }
};

export default expenseverseProductReducer;